import React, { useRef, useMemo, useContext, useEffect } from 'react';
import * as xstateReact from '@xstate/react';
import * as xstateModel from 'xstate/lib/model';
import axios from 'axios';

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var runtime = {exports: {}};

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

(function (module) {
  var runtime = /*#__PURE__*/function (exports) {

    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var undefined$1; // More compressible than void 0.

    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

    function define(obj, key, value) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
      return obj[key];
    }

    try {
      // IE 8 has a broken Object.defineProperty that only works on DOM objects.
      define({}, "");
    } catch (err) {
      define = function define(obj, key, value) {
        return obj[key] = value;
      };
    }

    function wrap(innerFn, outerFn, self, tryLocsList) {
      // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
      var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
      var generator = Object.create(protoGenerator.prototype);
      var context = new Context(tryLocsList || []); // The ._invoke method unifies the implementations of the .next,
      // .throw, and .return methods.

      generator._invoke = makeInvokeMethod(innerFn, self, context);
      return generator;
    }

    exports.wrap = wrap; // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.

    function tryCatch(fn, obj, arg) {
      try {
        return {
          type: "normal",
          arg: fn.call(obj, arg)
        };
      } catch (err) {
        return {
          type: "throw",
          arg: err
        };
      }
    }

    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed"; // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.

    var ContinueSentinel = {}; // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.

    function Generator() {}

    function GeneratorFunction() {}

    function GeneratorFunctionPrototype() {} // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.


    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function () {
      return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && /*#__PURE__*/getProto( /*#__PURE__*/getProto( /*#__PURE__*/values([])));

    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
      // This environment has a native %IteratorPrototype%; use it instead
      // of the polyfill.
      IteratorPrototype = NativeIteratorPrototype;
    }

    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = /*#__PURE__*/Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    define(Gp, "constructor", GeneratorFunctionPrototype);
    define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
    GeneratorFunction.displayName = /*#__PURE__*/define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"); // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.

    function defineIteratorMethods(prototype) {
      ["next", "throw", "return"].forEach(function (method) {
        define(prototype, method, function (arg) {
          return this._invoke(method, arg);
        });
      });
    }

    exports.isGeneratorFunction = function (genFun) {
      var ctor = typeof genFun === "function" && genFun.constructor;
      return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
      // do is to check its .name property.
      (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };

    exports.mark = function (genFun) {
      if (Object.setPrototypeOf) {
        Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
      } else {
        genFun.__proto__ = GeneratorFunctionPrototype;
        define(genFun, toStringTagSymbol, "GeneratorFunction");
      }

      genFun.prototype = Object.create(Gp);
      return genFun;
    }; // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.


    exports.awrap = function (arg) {
      return {
        __await: arg
      };
    };

    function AsyncIterator(generator, PromiseImpl) {
      function invoke(method, arg, resolve, reject) {
        var record = tryCatch(generator[method], generator, arg);

        if (record.type === "throw") {
          reject(record.arg);
        } else {
          var result = record.arg;
          var value = result.value;

          if (value && typeof value === "object" && hasOwn.call(value, "__await")) {
            return PromiseImpl.resolve(value.__await).then(function (value) {
              invoke("next", value, resolve, reject);
            }, function (err) {
              invoke("throw", err, resolve, reject);
            });
          }

          return PromiseImpl.resolve(value).then(function (unwrapped) {
            // When a yielded Promise is resolved, its final value becomes
            // the .value of the Promise<{value,done}> result for the
            // current iteration.
            result.value = unwrapped;
            resolve(result);
          }, function (error) {
            // If a rejected Promise was yielded, throw the rejection back
            // into the async generator function so it can be handled there.
            return invoke("throw", error, resolve, reject);
          });
        }
      }

      var previousPromise;

      function enqueue(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }

        return previousPromise = // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
        // invocations of the iterator.
        callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      } // Define the unified helper method that is used to implement .next,
      // .throw, and .return (see defineIteratorMethods).


      this._invoke = enqueue;
    }

    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
      return this;
    });
    exports.AsyncIterator = AsyncIterator; // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.

    exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
      if (PromiseImpl === void 0) PromiseImpl = Promise;
      var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
      return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function (result) {
        return result.done ? result.value : iter.next();
      });
    };

    function makeInvokeMethod(innerFn, self, context) {
      var state = GenStateSuspendedStart;
      return function invoke(method, arg) {
        if (state === GenStateExecuting) {
          throw new Error("Generator is already running");
        }

        if (state === GenStateCompleted) {
          if (method === "throw") {
            throw arg;
          } // Be forgiving, per 25.3.3.3.3 of the spec:
          // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume


          return doneResult();
        }

        context.method = method;
        context.arg = arg;

        while (true) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if (context.method === "next") {
            // Setting context._sent for legacy support of Babel's
            // function.sent implementation.
            context.sent = context._sent = context.arg;
          } else if (context.method === "throw") {
            if (state === GenStateSuspendedStart) {
              state = GenStateCompleted;
              throw context.arg;
            }

            context.dispatchException(context.arg);
          } else if (context.method === "return") {
            context.abrupt("return", context.arg);
          }

          state = GenStateExecuting;
          var record = tryCatch(innerFn, self, context);

          if (record.type === "normal") {
            // If an exception is thrown from innerFn, we leave state ===
            // GenStateExecuting and loop back for another invocation.
            state = context.done ? GenStateCompleted : GenStateSuspendedYield;

            if (record.arg === ContinueSentinel) {
              continue;
            }

            return {
              value: record.arg,
              done: context.done
            };
          } else if (record.type === "throw") {
            state = GenStateCompleted; // Dispatch the exception by looping back around to the
            // context.dispatchException(context.arg) call above.

            context.method = "throw";
            context.arg = record.arg;
          }
        }
      };
    } // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.


    function maybeInvokeDelegate(delegate, context) {
      var method = delegate.iterator[context.method];

      if (method === undefined$1) {
        // A .throw or .return when the delegate iterator has no .throw
        // method always terminates the yield* loop.
        context.delegate = null;

        if (context.method === "throw") {
          // Note: ["return"] must be used for ES3 parsing compatibility.
          if (delegate.iterator["return"]) {
            // If the delegate iterator has a return method, give it a
            // chance to clean up.
            context.method = "return";
            context.arg = undefined$1;
            maybeInvokeDelegate(delegate, context);

            if (context.method === "throw") {
              // If maybeInvokeDelegate(context) changed context.method from
              // "return" to "throw", let that override the TypeError below.
              return ContinueSentinel;
            }
          }

          context.method = "throw";
          context.arg = new TypeError("The iterator does not provide a 'throw' method");
        }

        return ContinueSentinel;
      }

      var record = tryCatch(method, delegate.iterator, context.arg);

      if (record.type === "throw") {
        context.method = "throw";
        context.arg = record.arg;
        context.delegate = null;
        return ContinueSentinel;
      }

      var info = record.arg;

      if (!info) {
        context.method = "throw";
        context.arg = new TypeError("iterator result is not an object");
        context.delegate = null;
        return ContinueSentinel;
      }

      if (info.done) {
        // Assign the result of the finished delegate to the temporary
        // variable specified by delegate.resultName (see delegateYield).
        context[delegate.resultName] = info.value; // Resume execution at the desired location (see delegateYield).

        context.next = delegate.nextLoc; // If context.method was "throw" but the delegate handled the
        // exception, let the outer generator proceed normally. If
        // context.method was "next", forget context.arg since it has been
        // "consumed" by the delegate iterator. If context.method was
        // "return", allow the original .return call to continue in the
        // outer generator.

        if (context.method !== "return") {
          context.method = "next";
          context.arg = undefined$1;
        }
      } else {
        // Re-yield the result returned by the delegate method.
        return info;
      } // The delegate iterator is finished, so forget it and continue with
      // the outer generator.


      context.delegate = null;
      return ContinueSentinel;
    } // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.


    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator"); // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.

    define(Gp, iteratorSymbol, function () {
      return this;
    });
    define(Gp, "toString", function () {
      return "[object Generator]";
    });

    function pushTryEntry(locs) {
      var entry = {
        tryLoc: locs[0]
      };

      if (1 in locs) {
        entry.catchLoc = locs[1];
      }

      if (2 in locs) {
        entry.finallyLoc = locs[2];
        entry.afterLoc = locs[3];
      }

      this.tryEntries.push(entry);
    }

    function resetTryEntry(entry) {
      var record = entry.completion || {};
      record.type = "normal";
      delete record.arg;
      entry.completion = record;
    }

    function Context(tryLocsList) {
      // The root entry object (effectively a try statement without a catch
      // or a finally block) gives us a place to store values thrown from
      // locations where there is no enclosing try statement.
      this.tryEntries = [{
        tryLoc: "root"
      }];
      tryLocsList.forEach(pushTryEntry, this);
      this.reset(true);
    }

    exports.keys = function (object) {
      var keys = [];

      for (var key in object) {
        keys.push(key);
      }

      keys.reverse(); // Rather than returning an object with a next method, we keep
      // things simple and return the next function itself.

      return function next() {
        while (keys.length) {
          var key = keys.pop();

          if (key in object) {
            next.value = key;
            next.done = false;
            return next;
          }
        } // To avoid creating an additional object, we just hang the .value
        // and .done properties off the next function object itself. This
        // also ensures that the minifier will not anonymize the function.


        next.done = true;
        return next;
      };
    };

    function values(iterable) {
      if (iterable) {
        var iteratorMethod = iterable[iteratorSymbol];

        if (iteratorMethod) {
          return iteratorMethod.call(iterable);
        }

        if (typeof iterable.next === "function") {
          return iterable;
        }

        if (!isNaN(iterable.length)) {
          var i = -1,
              next = function next() {
            while (++i < iterable.length) {
              if (hasOwn.call(iterable, i)) {
                next.value = iterable[i];
                next.done = false;
                return next;
              }
            }

            next.value = undefined$1;
            next.done = true;
            return next;
          };

          return next.next = next;
        }
      } // Return an iterator with no values.


      return {
        next: doneResult
      };
    }

    exports.values = values;

    function doneResult() {
      return {
        value: undefined$1,
        done: true
      };
    }

    Context.prototype = {
      constructor: Context,
      reset: function reset(skipTempReset) {
        this.prev = 0;
        this.next = 0; // Resetting context._sent for legacy support of Babel's
        // function.sent implementation.

        this.sent = this._sent = undefined$1;
        this.done = false;
        this.delegate = null;
        this.method = "next";
        this.arg = undefined$1;
        this.tryEntries.forEach(resetTryEntry);

        if (!skipTempReset) {
          for (var name in this) {
            // Not sure about the optimal order of these conditions:
            if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
              this[name] = undefined$1;
            }
          }
        }
      },
      stop: function stop() {
        this.done = true;
        var rootEntry = this.tryEntries[0];
        var rootRecord = rootEntry.completion;

        if (rootRecord.type === "throw") {
          throw rootRecord.arg;
        }

        return this.rval;
      },
      dispatchException: function dispatchException(exception) {
        if (this.done) {
          throw exception;
        }

        var context = this;

        function handle(loc, caught) {
          record.type = "throw";
          record.arg = exception;
          context.next = loc;

          if (caught) {
            // If the dispatched exception was caught by a catch block,
            // then let that catch block handle the exception normally.
            context.method = "next";
            context.arg = undefined$1;
          }

          return !!caught;
        }

        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          var record = entry.completion;

          if (entry.tryLoc === "root") {
            // Exception thrown outside of any try block that could handle
            // it, so set the completion value of the entire function to
            // throw the exception.
            return handle("end");
          }

          if (entry.tryLoc <= this.prev) {
            var hasCatch = hasOwn.call(entry, "catchLoc");
            var hasFinally = hasOwn.call(entry, "finallyLoc");

            if (hasCatch && hasFinally) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              } else if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else if (hasCatch) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              }
            } else if (hasFinally) {
              if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else {
              throw new Error("try statement without catch or finally");
            }
          }
        }
      },
      abrupt: function abrupt(type, arg) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
            var finallyEntry = entry;
            break;
          }
        }

        if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
          // Ignore the finally entry if control is not jumping to a
          // location outside the try/catch block.
          finallyEntry = null;
        }

        var record = finallyEntry ? finallyEntry.completion : {};
        record.type = type;
        record.arg = arg;

        if (finallyEntry) {
          this.method = "next";
          this.next = finallyEntry.finallyLoc;
          return ContinueSentinel;
        }

        return this.complete(record);
      },
      complete: function complete(record, afterLoc) {
        if (record.type === "throw") {
          throw record.arg;
        }

        if (record.type === "break" || record.type === "continue") {
          this.next = record.arg;
        } else if (record.type === "return") {
          this.rval = this.arg = record.arg;
          this.method = "return";
          this.next = "end";
        } else if (record.type === "normal" && afterLoc) {
          this.next = afterLoc;
        }

        return ContinueSentinel;
      },
      finish: function finish(finallyLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.finallyLoc === finallyLoc) {
            this.complete(entry.completion, entry.afterLoc);
            resetTryEntry(entry);
            return ContinueSentinel;
          }
        }
      },
      "catch": function _catch(tryLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.tryLoc === tryLoc) {
            var record = entry.completion;

            if (record.type === "throw") {
              var thrown = record.arg;
              resetTryEntry(entry);
            }

            return thrown;
          }
        } // The context.catch method must only be called with a location
        // argument that corresponds to a known catch block.


        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(iterable, resultName, nextLoc) {
        this.delegate = {
          iterator: values(iterable),
          resultName: resultName,
          nextLoc: nextLoc
        };

        if (this.method === "next") {
          // Deliberately forget the last sent value so that we don't
          // accidentally pass it on to the delegate.
          this.arg = undefined$1;
        }

        return ContinueSentinel;
      }
    }; // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.

    return exports;
  }( // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
  module.exports );

  try {
    regeneratorRuntime = runtime;
  } catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if (typeof globalThis === "object") {
      globalThis.regeneratorRuntime = runtime;
    } else {
      Function("r", "regeneratorRuntime = r")(runtime);
    }
  }
})(runtime);

var _regeneratorRuntime = runtime.exports;

function randomString() {
  var array = new Uint32Array(28);
  window.crypto.getRandomValues(array);
  return Array.from(array, function (dec) {
    return ('0' + dec.toString(16)).substr(-2);
  }).join('');
} // adapted from source: http://stackoverflow.com/a/11058858
// this is used in place of TextEncode as the api is not yet
// well supported: https://caniuse.com/#search=TextEncoder

function textEncodeLite(str) {
  var buf = new ArrayBuffer(str.length);
  var bufView = new Uint8Array(buf);

  for (var i = 0; i < str.length; i++) {
    bufView[i] = str.charCodeAt(i);
  }

  return bufView;
} // Calculate the SHA256 hash of the input text.
// Returns a promise that resolves to an ArrayBuffer


function sha256(plain) {
  var data = textEncodeLite(plain);
  return crypto.subtle.digest('SHA-256', data);
} // Base64-urlencodes the input string


function base64urlencode(str) {
  // Convert the ArrayBuffer to string using Uint8 array to convert to what btoa accepts.
  // btoa accepts chars only within ascii 0-255 and base64 encodes them.
  // Then convert the base64 encoded to base64url encoded
  //   (replace + with -, replace / with _, trim trailing =)
  return btoa(String.fromCharCode.apply(null, Array.from(new Uint8Array(str)))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
} // Return the base64-urlencoded sha256 hash for the PKCE challenge


function pkceChallengeFromVerifier(_x) {
  return _pkceChallengeFromVerifier.apply(this, arguments);
}

function _pkceChallengeFromVerifier() {
  _pkceChallengeFromVerifier = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(v) {
    var hashed;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return sha256(v);

          case 2:
            hashed = _context.sent;
            return _context.abrupt("return", base64urlencode(hashed));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _pkceChallengeFromVerifier.apply(this, arguments);
}

var sessionWrapper = {
  getItem: function getItem(key) {
    return window.sessionStorage.getItem(key);
  },
  setItem: function setItem(key, value) {
    return window.sessionStorage.setItem(key, value);
  },
  removeItem: function removeItem(key) {
    return window.sessionStorage.removeItem(key);
  }
};

var IframeHandler = /*#__PURE__*/function () {
  function IframeHandler(options) {
    this.url = void 0;
    this.callback = void 0;
    this.timeout = void 0;
    this.timeoutCallback = void 0;
    this.eventListenerType = void 0;
    this.eventValidator = void 0;
    this.iframe = void 0;
    this.timeoutHandle = void 0;
    this._destroyTimeout = void 0;
    this.proxyEventListener = void 0;
    this.eventSourceObject = void 0;
    this.url = options.url;
    this.callback = options.callback;
    this.timeout = options.timeout || 60 * 1000;
    this.timeoutCallback = options.timeoutCallback || null;
    this.eventListenerType = options.eventListenerType || 'message';
    this._destroyTimeout = null; // If no event identifier specified, set default

    this.eventValidator = options.eventValidator || {
      isValid: function isValid() {
        return true;
      }
    };

    if (typeof this.callback !== 'function') {
      throw new Error('options.callback must be a function');
    }

    var _this = this;

    var _window = window;
    var iframeId = options.iframeDomId;
    this.iframe = _window.document.createElement('iframe');
    this.iframe.style.display = 'none';
    this.iframe.setAttribute('id', iframeId); // Workaround to avoid using bind that does not work in IE8

    this.proxyEventListener = function (e) {
      _this.eventListener(e);
    };

    switch (this.eventListenerType) {
      case 'message':
        this.eventSourceObject = _window;
        break;

      case 'load':
        this.eventSourceObject = this.iframe;
        break;

      default:
        throw new Error('Unsupported event listener type: ' + this.eventListenerType);
    }

    this.eventSourceObject.addEventListener(this.eventListenerType, this.proxyEventListener, false);

    _window.document.body.appendChild(this.iframe);

    this.iframe.src = this.url;
    this.timeoutHandle = setTimeout(function () {
      _this.timeoutHandler();
    }, this.timeout);
  }

  var _proto = IframeHandler.prototype;

  _proto.eventListener = function eventListener(event) {
    var eventData = {
      event: event,
      sourceObject: this.eventSourceObject
    };

    if (!this.eventValidator.isValid(eventData)) {
      return;
    }

    this.destroy();
    this.callback(eventData);
  };

  _proto.timeoutHandler = function timeoutHandler() {
    this.destroy();

    if (this.timeoutCallback) {
      this.timeoutCallback();
    }
  };

  _proto.destroy = function destroy() {
    var _this = this;

    if (this.timeoutHandle) {
      clearTimeout(this.timeoutHandle);
    }

    this._destroyTimeout = setTimeout(function () {
      if (_this.eventSourceObject && _this.proxyEventListener) {
        _this.eventSourceObject.removeEventListener(_this.eventListenerType, _this.proxyEventListener, false);
      }
    }, 0);
  };

  return IframeHandler;
}();

/* eslint-disable @typescript-eslint/no-this-alias */

var SilentAuthentication = /*#__PURE__*/function () {
  function SilentAuthentication(options) {
    this.authenticationUrl = void 0;
    this.timeout = void 0;
    this.postMessageDataType = void 0;
    this.postMessageOrigin = void 0;
    this.iframeDomId = void 0;
    this.handler = void 0;
    this.authenticationUrl = options.authenticationUrl;
    this.timeout = options.timeout || 60 * 1000;
    this.handler = null;
    this.postMessageDataType = options.postMessageDataType || false;
    this.iframeDomId = options.iframeDomId;
    var _window = window; // prefer origin from options, fallback to origin from browser, and some browsers (for example MS Edge) don't support origin; fallback to construct origin manually

    this.postMessageOrigin = options.postMessageOrigin || _window.location.origin || _window.location.protocol + '//' + _window.location.hostname + (_window.location.port ? ':' + _window.location.port : '');
  }

  var _proto = SilentAuthentication.prototype;

  _proto.login = function login(usePostMessage, callback) {
    this.handler = new IframeHandler({
      url: this.authenticationUrl,
      eventListenerType: usePostMessage ? 'message' : 'load',
      callback: this.getCallbackHandler(callback, usePostMessage),
      timeout: this.timeout,
      eventValidator: this.getEventValidator(),
      iframeDomId: this.iframeDomId,
      timeoutCallback: function timeoutCallback() {
        callback(null, '#error=timeout&error_description=Timeout+during+authentication+renew.');
      }
    });
  };

  _proto.getEventValidator = function getEventValidator() {
    var _this = this;

    return {
      isValid: function isValid(eventData) {
        var _this$handler, _this$handler$iframe;

        switch (eventData.event.type) {
          case 'message':
            // Message must come from the expected origin and iframe window.
            if (eventData.event.origin !== _this.postMessageOrigin || eventData.event.source !== (_this == null ? void 0 : (_this$handler = _this.handler) == null ? void 0 : (_this$handler$iframe = _this$handler.iframe) == null ? void 0 : _this$handler$iframe.contentWindow)) {
              return false;
            } // Default behaviour, return all message events from the iframe.


            if (_this.postMessageDataType === false) {
              return true;
            }

            return eventData.event.data.type && eventData.event.data.type === _this.postMessageDataType;

          case 'load':
            {
              var _sourceObject$content;

              var sourceObject = eventData == null ? void 0 : eventData.sourceObject;

              if ((sourceObject == null ? void 0 : (_sourceObject$content = sourceObject.contentWindow) == null ? void 0 : _sourceObject$content.location.protocol) === 'about:') {
                // Chrome is automatically loading the about:blank page, we ignore this.
                return false;
              }

              break;
            }
          // Fall through to default

          default:
            return true;
        }

        return true;
      }
    };
  };

  _proto.getCallbackHandler = function getCallbackHandler(callback, usePostMessage) {
    return function (eventData) {
      var callbackValue;
      var iframeSourceObject = eventData == null ? void 0 : eventData.sourceObject;

      if (!usePostMessage && iframeSourceObject) {
        var _iframeSourceObject$c;

        callbackValue = (_iframeSourceObject$c = iframeSourceObject.contentWindow) == null ? void 0 : _iframeSourceObject$c.location.search;
      } else if (typeof eventData.event.data === 'object' && eventData.event.data.search) {
        callbackValue = eventData.event.data.search;
      } else {
        callbackValue = eventData.event.data;
      }

      callback(null, callbackValue);
    };
  };

  return SilentAuthentication;
}();

function assign(url) {
  window.location.assign(url);
}

var OAUTH_RESPONSE_TYPE = 'code';
var OAUTH_CODE_CHALLENGE_METHOD = 'S256';
var OAUTH_CODE_VERIFIER_KEY = 'code_verifier';
var OAUTH_AUTH_CODE_GRANT_TYPE = 'authorization_code';
var OAUTH_USER_SCOPE = 'user:full:read';

function oAuthAuthorizeUrl(_x, _x2) {
  return _oAuthAuthorizeUrl.apply(this, arguments);
}

function _oAuthAuthorizeUrl() {
  _oAuthAuthorizeUrl = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(config, props) {
    var codeVerifier, codeChallenge, prompt, params;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            codeVerifier = randomString();
            _context3.next = 3;
            return pkceChallengeFromVerifier(codeVerifier);

          case 3:
            codeChallenge = _context3.sent;
            // save verification code for later use
            sessionWrapper.setItem(OAUTH_CODE_VERIFIER_KEY, codeVerifier);
            prompt = props == null ? void 0 : props.prompt;
            params = new URLSearchParams(_extends({
              response_type: OAUTH_RESPONSE_TYPE,
              code_challenge_method: OAUTH_CODE_CHALLENGE_METHOD,
              scope: OAUTH_USER_SCOPE,
              redirect_uri: config.oAuthRedirectUri,
              client_id: config.clientId,
              code_challenge: codeChallenge
            }, prompt && {
              prompt: prompt
            }));
            return _context3.abrupt("return", config.oAuthAuthorizeUrl + '?' + params.toString());

          case 8:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _oAuthAuthorizeUrl.apply(this, arguments);
}

function assignAuthorizeURL(_x3, _x4) {
  return _assignAuthorizeURL.apply(this, arguments);
}

function _assignAuthorizeURL() {
  _assignAuthorizeURL = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(config, props) {
    var url;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return oAuthAuthorizeUrl(config, props);

          case 2:
            url = _context4.sent;
            assign(url);

          case 4:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _assignAuthorizeURL.apply(this, arguments);
}

function assignBrowserLogoutUrl(_x5) {
  return _assignBrowserLogoutUrl.apply(this, arguments);
}

function _assignBrowserLogoutUrl() {
  _assignBrowserLogoutUrl = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(config) {
    var postLogoutRedirect, params, url;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.t0 = config.postLogoutRedirectUri;

            if (_context5.t0) {
              _context5.next = 5;
              break;
            }

            _context5.next = 4;
            return oAuthAuthorizeUrl(config);

          case 4:
            _context5.t0 = _context5.sent;

          case 5:
            postLogoutRedirect = _context5.t0;
            params = new URLSearchParams({
              post_logout_redirect_uri: postLogoutRedirect
            });
            url = config.oAuthLogoutUrl + '?' + params.toString();
            assign(url);

          case 9:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _assignBrowserLogoutUrl.apply(this, arguments);
}

var CODE_VERIFIER_ERROR = 'No Code Verifier to Complete Authentication';
function buildOauthTokenParams(config, code) {
  var codeVerifier = sessionWrapper.getItem(OAUTH_CODE_VERIFIER_KEY);

  if (!codeVerifier) {
    throw new Error(CODE_VERIFIER_ERROR);
  }

  var params = _extends({
    grant_type: OAUTH_AUTH_CODE_GRANT_TYPE,
    client_id: config.clientId,
    redirect_uri: config.oAuthRedirectUri,
    code_verifier: codeVerifier,
    code: code
  }, config.clientSecret && {
    client_secret: config.clientSecret
  });

  return new URLSearchParams(params);
}
function exchangeOAuthCodeForToken(_x6, _x7) {
  return _exchangeOAuthCodeForToken.apply(this, arguments);
}

function _exchangeOAuthCodeForToken() {
  _exchangeOAuthCodeForToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(config, code) {
    var params, data;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            params = buildOauthTokenParams(config, code);
            _context6.next = 3;
            return axios.post(config.oAuthTokenUrl, params.toString(), {
              headers: {
                'content-type': 'application/x-www-form-urlencoded'
              }
            });

          case 3:
            data = _context6.sent;
            sessionWrapper.removeItem(OAUTH_CODE_VERIFIER_KEY);
            return _context6.abrupt("return", data);

          case 6:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _exchangeOAuthCodeForToken.apply(this, arguments);
}

var urlSearchParamsToObject = function urlSearchParamsToObject(search) {
  if (!search) {
    return {};
  }

  var searchParams = new URLSearchParams(search);
  var result = {};
  searchParams.forEach(function (value, key) {
    result[key] = value;
  });
  return result;
};

var iframeDomId = 'cf_silent_auth_check';
var getAuthIframe = function getAuthIframe() {
  return document.getElementById(iframeDomId);
};
var renewAuth = /*#__PURE__*/function () {
  var _ref = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(config, onReceive) {
    var authIframe, authenticationUrl, handler;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            authIframe = getAuthIframe();

            if (!authIframe) {
              _context2.next = 5;
              break;
            }

            return _context2.abrupt("return");

          case 5:
            _context2.next = 7;
            return oAuthAuthorizeUrl(config, {
              prompt: 'none'
            });

          case 7:
            authenticationUrl = _context2.sent;
            handler = new SilentAuthentication({
              authenticationUrl: authenticationUrl,
              iframeDomId: iframeDomId
            });
            handler.login(false, /*#__PURE__*/function () {
              var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_err, search) {
                var result, tokenDetails;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        result = urlSearchParamsToObject(search);

                        if (!result.code) {
                          _context.next = 8;
                          break;
                        }

                        _context.next = 4;
                        return exchangeOAuthCodeForToken(config, result.code);

                      case 4:
                        tokenDetails = _context.sent;
                        onReceive(undefined, tokenDetails.data);
                        _context.next = 9;
                        break;

                      case 8:
                        onReceive({
                          error: result.error,
                          errorDescription: result.error_description
                        }, undefined);

                      case 9:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function (_x10, _x11) {
                return _ref2.apply(this, arguments);
              };
            }());

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function renewAuth(_x8, _x9) {
    return _ref.apply(this, arguments);
  };
}();

function windowIsIframe() {
  return window.self !== window.top;
}

var createModel = xstateModel.createModel;
function createOAuthMachine(config) {
  var pkceOauthModel = createModel({
    tokenDetails: undefined,
    code: undefined,
    error: undefined
  }, {
    events: {
      INITIATE_LOGOUT: function INITIATE_LOGOUT() {
        return {};
      },
      INITIATE_AUTH_FLOW: function INITIATE_AUTH_FLOW() {
        return {};
      },
      REPORT_AUTHENTICATED: function REPORT_AUTHENTICATED(value) {
        return {
          value: value
        };
      },
      REPORT_UNAUTHENTICATED: function REPORT_UNAUTHENTICATED(error) {
        return {
          error: error
        };
      }
    },
    actions: {
      returnToExternalAuth: function returnToExternalAuth() {
        return {};
      }
    }
  });
  var clearTokenDetails = pkceOauthModel.assign({
    tokenDetails: function tokenDetails() {
      return undefined;
    }
  });
  var assignTokenDetailsToContext = pkceOauthModel.assign({
    tokenDetails: function tokenDetails(_context, event) {
      return event.value;
    }
  }, 'REPORT_AUTHENTICATED');
  var assignErrorToContext = pkceOauthModel.assign({
    error: function error(_context, event) {
      return event.error;
    }
  }, 'REPORT_UNAUTHENTICATED');
  var pkceOAuthMachine = pkceOauthModel.createMachine({
    id: 'pkceOauthFlow',
    context: pkceOauthModel.initialContext,
    initial: 'checkingIfAuthenticated',
    on: {
      INITIATE_LOGOUT: {
        target: 'unauthenticated',
        actions: 'returnToExternalAuth'
      }
    },
    states: {
      checkingIfAuthenticated: {
        always: {
          target: 'unauthenticated.final',
          cond: function cond() {
            return windowIsIframe();
          }
        },
        invoke: {
          src: 'renewAuthentication',
          onError: {
            target: 'unauthenticated'
          }
        },
        on: {
          REPORT_AUTHENTICATED: {
            target: 'authenticated',
            actions: [assignTokenDetailsToContext]
          },
          REPORT_UNAUTHENTICATED: {
            target: 'unauthenticated',
            actions: assignErrorToContext
          }
        }
      },
      authenticated: {},
      unauthenticated: {
        initial: 'noToken',
        on: {
          REPORT_AUTHENTICATED: {
            target: 'authenticated',
            actions: [assignTokenDetailsToContext]
          }
        },
        states: {
          "final": {
            type: 'final'
          },
          noToken: {
            entry: [clearTokenDetails],
            on: {
              INITIATE_AUTH_FLOW: {
                actions: 'returnToExternalAuth'
              }
            }
          }
        }
      }
    }
  }, {
    services: {
      renewAuthentication: function renewAuthentication() {
        return /*#__PURE__*/function () {
          var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(send) {
            return _regeneratorRuntime.wrap(function _callee$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    _context2.next = 2;
                    return renewAuth(config, function (error, tokenDetails) {
                      if (tokenDetails) {
                        send({
                          type: 'REPORT_AUTHENTICATED',
                          value: {
                            access_token: tokenDetails.access_token,
                            expires_in: tokenDetails.expires_in
                          }
                        });
                      } else {
                        send({
                          type: 'REPORT_UNAUTHENTICATED',
                          error: error
                        });
                      }
                    });

                  case 2:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee);
          }));

          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }();
      }
    },
    actions: {
      returnToExternalAuth: function () {
        var _returnToExternalAuth = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_context, event) {
          return _regeneratorRuntime.wrap(function _callee2$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  if (!(event.type === 'INITIATE_AUTH_FLOW')) {
                    _context3.next = 5;
                    break;
                  }

                  _context3.next = 3;
                  return assignAuthorizeURL(config);

                case 3:
                  _context3.next = 8;
                  break;

                case 5:
                  if (!(event.type === 'INITIATE_LOGOUT')) {
                    _context3.next = 8;
                    break;
                  }

                  _context3.next = 8;
                  return assignBrowserLogoutUrl(config);

                case 8:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee2);
        }));

        function returnToExternalAuth(_x2, _x3) {
          return _returnToExternalAuth.apply(this, arguments);
        }

        return returnToExternalAuth;
      }()
    }
  });
  return pkceOAuthMachine;
}

var AuthContext = /*#__PURE__*/React.createContext({
  initiateLogin: undefined,
  initiateLogoutFlow: undefined,
  authenticated: false,
  unauthenticated: true
});
function AuthProvider(_ref) {
  var children = _ref.children,
      config = _ref.config;

  var _React$useState = React.useState(false),
      authenticated = _React$useState[0],
      setAuthenticated = _React$useState[1];

  var _React$useState2 = React.useState(true),
      unauthenticated = _React$useState2[0],
      setUnauthenticated = _React$useState2[1];

  var eventSendDownStreamRef = useRef(undefined);
  var machine = useMemo(function () {
    return createOAuthMachine(config);
  }, [config.clientId]);
  var oauthService = xstateReact.useInterpret(machine, {}, function (state) {
    var tokenDetails = state.context.tokenDetails;
    var isAuthedMatch = state.matches('authenticated');
    var isUnauthedMatch = state.matches('unauthenticated');

    if (authenticated !== isAuthedMatch) {
      setAuthenticated(isAuthedMatch);
    }

    if (unauthenticated !== isUnauthedMatch) {
      setUnauthenticated(isUnauthedMatch);
    }

    if (tokenDetails != null && tokenDetails.access_token && typeof tokenDetails !== 'undefined' && !eventSendDownStreamRef.current) {
      eventSendDownStreamRef.current = tokenDetails;
      config.onReceiveAccessToken(tokenDetails);
    }
  });
  var state = {
    initiateLogin: function initiateLogin() {
      return oauthService.send('INITIATE_AUTH_FLOW');
    },
    initiateLogoutFlow: function initiateLogoutFlow() {
      return oauthService.send('INITIATE_LOGOUT');
    },
    authenticated: authenticated,
    unauthenticated: unauthenticated
  };
  return React.createElement(AuthContext.Provider, {
    value: state
  }, children);
}

function useAuth() {
  return useContext(AuthContext);
}
function useEnforceLogin() {
  var oauth = useAuth();
  useEffect(function () {
    if (oauth.unauthenticated) {
      oauth.initiateLogin();
    }
  }, [oauth.unauthenticated]);
  return oauth;
}

export { AuthContext, AuthProvider, useAuth, useEnforceLogin };
//# sourceMappingURL=auth.esm.js.map
